/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-relative-packages */
/* eslint-disable no-shadow */
import { useMemo, Suspense } from 'react'
import useLoadModules, { Status } from '@maas-tools/module-federation'
import NestedBrowserRouter from '@maas-tools/nested-browser-router'
import { ErrorBoundary } from 'react-error-boundary'
import { useLocation } from 'react-router-dom'
import { EInternalStatus } from 'core/common/constants/settings'
import useSellerPermissions from 'core/common/hooks/useSellerPermissions'
import coreRoutes from 'core/routes'
import channelRoutes from 'magalu/routes'
import ErrorFallback from '../ErrorFallback'
import ErrorPage from '../ErrorPage'
import useSelectedModule from './hooks/useSelectedModule'
import LoadingModule from './loading'
import { TAllStatus, TModule } from './type'

type TMappingStatus = Record<
  TAllStatus,
  (module: TModule, AppExport: React.ReactNode) => React.ReactElement | null
>

const routes = [...coreRoutes, ...channelRoutes]

const renderExternalModule = (module: TModule, exposes: any) => {
  const { default: DefaultApp } = exposes
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Suspense fallback={<LoadingModule />}>
        <NestedBrowserRouter basename={module?.prefix as string}>
          <DefaultApp />
        </NestedBrowserRouter>
      </Suspense>
    </ErrorBoundary>
  )
}

const StatusMapping: TMappingStatus = {
  [EInternalStatus.INTERNAL]: () => null, // não retorna nada pois é uma rota ja renderizada.
  [EInternalStatus.FORBIDDEN]: () => <ErrorPage errorType="Forbidden" />,
  [Status.ERROR]: () => <ErrorPage errorType="InternalError" />,
  [Status.NOT_FOUND]: () => <ErrorPage errorType="NotFound" />,
  [Status.UNKNOWN]: () => <ErrorPage errorType="Unavailable" />,
  [Status.LOADING]: () => <LoadingModule />,
  [Status.LOADED]: (module, exposes) => renderExternalModule(module, exposes),
}

const isInternalModule = (pathname: string) => {
  return routes.some(route => {
    return new RegExp(`^${route.path.replace(/:\w+/g, '[^/]+')}/?$`).test(pathname)
  })
}

const LoadModules = () => {
  const { pathname } = useLocation()
  const path = pathname.split('/')[1]
  const validationPath = `/${path}`

  const internalModule = !pathname || isInternalModule(pathname)
  const selectedModule = useSelectedModule(validationPath) || null
  const { status, exposes } = useLoadModules(selectedModule)
  const { hasPermissionsInModule } = useSellerPermissions()

  const hasPermission = useMemo(
    () => hasPermissionsInModule(selectedModule),
    [selectedModule, hasPermissionsInModule]
  )

  const renderStatus: TAllStatus = useMemo(() => {
    if (internalModule) return EInternalStatus.INTERNAL // condição necessariamente em primeiro lugar
    if (!selectedModule) return Status.NOT_FOUND
    if (!hasPermission) return EInternalStatus.FORBIDDEN

    return status
  }, [hasPermission, internalModule, selectedModule, status])

  const renderFromStatus = StatusMapping[renderStatus]

  return renderFromStatus(selectedModule as TModule, exposes)
}

export default LoadModules
